module.exports = __webpack_public_path__ + "static/img/main.2f11f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/Lifegoeson/bottom/part2/main.jpg
// module id = rRm4
// module chunks = 0